import { render, staticRenderFns } from "./ChooseItRight.vue?vue&type=template&id=11c9827a&lang=pug&"
import script from "./ChooseItRight.vue?vue&type=script&lang=js&"
export * from "./ChooseItRight.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports